// extracted by mini-css-extract-plugin
export default {"modalContainer":"ProductDescriptionModal_modalContainer__kIb7W"};